export default function RotateCw(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={25} height={24} {...props}>
      <path d="M20.682 4.568c.42 0 .765.316.813.723l.005.095v4.91c0 .42-.316.766-.723.813l-.095.005h-4.91a.818.818 0 0 1-.095-1.63l.095-.006h4.091V5.386c0-.42.316-.765.723-.813l.096-.005Z" />
      <path d="M7.732 4.768a8.177 8.177 0 0 1 9.545 1.193l.177.172L21.243 9.7a.818.818 0 0 1-1.043 1.258l-.08-.066-3.806-3.585a6.546 6.546 0 1 0 1.542 6.808.818.818 0 1 1 1.543.545A8.183 8.183 0 1 1 7.732 4.768Z" />
    </svg>
  );
}
